/** Live-Anzeige der Passwortregeln (li.ok bei Erfüllung), wie im Web. */
import { PW_RULES } from "./password-rules";

export function PasswordRules({ value }: { value: string }) {
  return (
    <ul class="pw-rules" aria-live="polite">
      {PW_RULES.map((r) => (
        <li key={r.key} class={r.test(value) ? "ok" : undefined}>
          {r.label}
        </li>
      ))}
    </ul>
  );
}
